import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectAllowLogin } from '@us/web/shop/data-access';

export const checkAllowLoginGuard = async () => {
    const router = inject(Router);
    const store = inject(Store);
    const allowLogin = store.selectSignal(selectAllowLogin)();
    if (!allowLogin) {
        await router.navigateByUrl('/');
    }
    return allowLogin;
};
